"use client";
import Image from "@/node_modules/next/image";
import Link from "@/node_modules/next/link";
import { Grid, Skeleton } from "@mui/material";
import { Box, Typography } from "@mui/material";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import "./index.css";
import { Loader } from "../genericComponents/MainLoader/Loader";
import { useEffect, useState } from "react";
import { trackEvent } from "@/app/utils/branch";

interface CategoryHeaderProps {
  categories: any;
}

const CategoryHeader: React.FC<CategoryHeaderProps> = ({ categories }) => {
  const [loading, setLoading] = useState(false);
  return (
    <>
      {loading && <Loader />}
      <Grid
        container
        item
        xs={11.5}
        sm={11}
        md={9.5}
        lg={9.5}
        margin="auto"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          margin: { xs: "1rem auto", sm: "auto" },
        }}
      >
        <Box sx={{ width: "100%", textAlign: "left" }}>
          <Typography
            variant="h5"
            sx={{ fontWeight: "bold" }}
            className="category-service-heading"
          >
            Explore By Categories
          </Typography>
        </Box>
        <Box
          className="navigating-container"
          sx={{
            display: { xs: "contents", sm: "flex" },
            alignItems: "center",
            justifyContent: "flex-start",
            overflowX: "scroll",
            textAlign: "center",
          }}
        >
          {categories && categories.length > 0
            ? categories.map((c: any, i: number) => (
                <CategoryTile
                  key={i}
                  category={c}
                  setLoading={setLoading}
                ></CategoryTile>
              ))
            : Array.from({ length: 7 }).map((_, i) => (
                <Skeleton
                  key={i}
                  variant="rounded"
                  sx={{
                    margin: "auto 0.5rem",
                    width: { xs: "100px", sm: "160px" },
                    height: { xs: "100px", sm: "160px" },
                  }}
                />
              ))}
        </Box>
      </Grid>
    </>
  );
};

interface CategoryTileProps {
  category: any;
  setLoading: any;
}

const CategoryTile: React.FC<CategoryTileProps> = ({
  category,
  setLoading,
}) => {
  const [serviceHubSlug, setServiceHubSlug] = useState("noida");

  useEffect(() => {
    try {
      const storedSlug = localStorage.getItem("serviceHubSlug");
      if (storedSlug) {
        const decodedSlug = JSON.parse(atob(storedSlug));
        if (decodedSlug) {
          setServiceHubSlug(decodedSlug);
        }
      }
    } catch (error) {
      console.error("Error decoding or parsing serviceHubSlug:", error);
    }
  }, []);

  return (
    <Link
      prefetch={false}
      href={serviceHubSlug + "/" + category?.slug}
      passHref
      style={{ textDecoration: "none", color: "inherit" }}
      onClick={() => {
        setLoading(true);
        trackEvent("SERVICE_VIEW", category?.id);
      }}
    >
      <Box
        sx={{
          borderRadius: { xs: "10px", sm: "16px" },
          width: "max-content",
          boxShadow: { xs: "none", sm: "2px 2px 4px 2px rgba(0, 0, 0, 0.1)" },
          margin: { xs: "5px", sm: "1rem 1.5rem 1rem 0px" },
          cursor: "pointer",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Image
          src={category?.mobileImage?.secureHttpPath}
          width={500}
          height={500}
          className="category-header-images"
          style={{
            margin: "auto",
            objectFit: "cover",
          }}
          alt="category"
          loading="lazy"
        />
        <Box
          sx={{
            textWrap: { xs: "wrap", sm: "nowrap" },
            margin: { xs: "auto", sm: "auto" },
            maxWidth: { xs: "100%", sm: "100%" },
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            bottom: 0,
            background:
              "linear-gradient(to top, rgba(0, 0, 0, 0.9) 35%, rgba(0, 0, 0, 0))",
            position: "absolute",
            width: "100%",
            height: "25%",
          }}
        >
          {" "}
          <Typography
            className="text-center text-sm"
            sx={{
              fontWeight: "bold",
              fontSize: { xs: "11px", sm: "14px" },
              color: { xs: "#fff", sm: "#fff" },
            }}
          >
            {category.name}
          </Typography>
          <ArrowRightIcon
            sx={{ display: { xs: "visible", sm: "none" }, fontSize: "14px" }}
          />
        </Box>
      </Box>
    </Link>
  );
};

export default CategoryHeader;
